import React from "react";
import { createUseStyles, useTheme } from "react-jss";
import { ThemeType } from "../../styles/theme";
import clsx from "clsx";
import { CategoryData } from "../../types";

interface Props {
   category: CategoryData;
   isClicked: boolean;
}

const useStyles = createUseStyles((theme: ThemeType) => ({
   button: {
      fontSize: "1.4rem",
      fontWeight: theme.demiLight,
      padding: "8px 16px",
      borderRadius: 25,
      border: `1px solid ${theme.monoDivider}`,
      margin: "0px 10px 10px 0px",
      "&.clicked": {
         fontWeight: theme.medium,
         color: theme.mono100,
         background: theme.primarySol,
         border: `1px solid ${theme.primarySol}`,
      },
   },
}));

const CategoryButton: React.FC<Props> = (props) => {
   const theme = useTheme<ThemeType>();
   const classes = useStyles({ theme });
   const {
      category: { label },
      isClicked,
   } = props;

   return (
      <div className={clsx(classes.button, isClicked && "clicked")}>
         {label}
      </div>
   );
};

export default CategoryButton;
